import React from 'react'
import PropTypes from 'prop-types'

import { arrowInc } from '../Forms/statusForms/image'

const MobSelectButton = ({value, title, onClick, dataTitle, textValid, disabled}) => {
  return(
    <button
      className={`mob-select-button ${textValid && "error-validation"}`}
      type='button'
      data-title={dataTitle}
      onClick={onClick}
      disabled={disabled}
    >
      <span className="title">{title || ''}</span>
      <div className="value-container">
        <span className={`value ${value.length === 0 && 'empty'}`}>{value || 'Потрібно обрати'}</span>
        {arrowInc}
      </div>
    </button>
  )
}

MobSelectButton.propTypes = {
  value: PropTypes.string,
  title: PropTypes.string,
  onClick: PropTypes.func,
  dataTitle: PropTypes.string,
  textValid: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool
  ]),
  disabled: PropTypes.bool
}

export default MobSelectButton